import { authClient, API } from "../../utils/index";

export const getPromoClientsAdmin = () => {
	return authClient().get(`${API}/promo-client?all=1`);
};

export const getPromoClientById = (id) => {
	return authClient().get(`${API}/promo-client/${id}`);
};

export const postPromoClient = (body) => {
	return authClient().post(`${API}/promo-client`, body);
};

export const putPromoClient = (id, body) => {
	return authClient().put(`${API}/promo-client/${id}`, body);
};

export const movePromoClient = (id, direction) => {
	return authClient().post(`${API}/promo-client/${id}/move`, { direction });
};

export const deletePromoClient = (id) => {
	return authClient().delete(`${API}/promo-client/${id}`);
};
